// import BibleQuote from '../BibleQuote/BibleQuote';
import './Header.css';

const Header = () => {
  return (
    <header>
      {/* <BibleQuote
        quote="Missä on aarteesi, siellä on myös sydämesi."
        source="Matt. 6:21"
      /> */}
      {/* <div className="header-text right-side">
        <p className="lower">19 / 3 / 2021</p>
        <p className="upper">Avaat Uuden Sivun</p>
      </div> */}

      <div className="header-text left-side">
        <p className="upper laurimikael-font">LAURI MIKAEL</p>
      </div>

    </header>
  )
}

export default Header;